import React from 'react';
import CommonFourthStep from '../CommonFourthStep';

function FourthStep(props) {
  return (
    <CommonFourthStep
      reportType="Laminate"
      props={props}
    />
  );
}

export default FourthStep;
